module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.accountDetails) ? _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', {
    staticClass: "display-4 text-center"
  }, [_vm._v(_vm._s(_vm.accountDetails.nickname))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.community')))]), _vm._v(" "), _c('p', [(_vm.accountDetails.community) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'communityDetails',
        params: {
          communitySlug: _vm.accountDetails.community.slug
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.accountDetails.community.name))]) : _vm._e(), _vm._v(" "), (!_vm.accountDetails.community) ? _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('account.notAssociated')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('account.timezone')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.timezone) + "\n            "), _c('span', {
    staticClass: "text-muted small",
    attrs: {
      "if": "currentTime"
    }
  }, [_vm._v("(" + _vm._s(_vm.$t('account.currentTime')) + " " + _vm._s(_vm.currentTime) + ")")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.accountEditModal",
      modifiers: {
        "accountEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit')) + "\n        ")]), _vm._v(" \n        "), _c('b-popover', {
    attrs: {
      "content": _vm.$t('button.refresh.authentication.explanation'),
      "triggers": ['hover']
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.refreshAuthentication
    }
  }, [_c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh.authentication')) + "\n          ")])], 1), _vm._v(" \n        "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.accountDeleteModal",
      modifiers: {
        "accountDeleteModal": true
      }
    }],
    attrs: {
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete.account')) + "\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('nav.missions')))]), _vm._v(" "), _c('account-missions')], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('account.permissions')))]), _vm._v(" "), _c('account-permissions')], 1)])]) : _vm._e(), _vm._v(" "), _c('div', [_c('account-delete-modal'), _vm._v(" "), _c('account-edit-modal')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dae4ff7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Account.vue
// module id = 535
// module chunks = 0